export const TIERS = ["user", "contributor", "reviewer", "admin"] as const;
export type ProductRoleTier = (typeof TIERS)[number];

export const TIER_LABELS: Record<ProductRoleTier, string> = {
  user: "User",
  contributor: "Contributor",
  reviewer: "Reviewer",
  admin: "Admin",
};

// Lower number = higher privilege. Contributor outranks Reviewer since it grants
// strictly more features (e.g. in Underwriting Engine, Contributor = Reviewer's
// features + Guardrail Controller access).
export const TIER_PRIORITY: Record<ProductRoleTier, number> = {
  admin: 0,
  contributor: 1,
  reviewer: 2,
  user: 3,
};

const ROLE_NAME_PATTERN = /^(\d+)-(user|contributor|reviewer|admin)$/;

export function productRoleName(productId: number, tier: ProductRoleTier): string {
  return `${productId}-${tier}`;
}

export function parseProductRoleName(
  name: string
): { productId: number; tier: ProductRoleTier } | null {
  const match = ROLE_NAME_PATTERN.exec(name);
  if (!match) {
    return null;
  }
  return { productId: Number(match[1]), tier: match[2] as ProductRoleTier };
}

// Every product-role name that satisfies "at least this tier" for a product,
// e.g. rolesAtOrAbove(23, "reviewer") -> ["23-contributor", "23-reviewer", "23-admin"].
export function rolesAtOrAbove(productId: number, tier: ProductRoleTier): string[] {
  return TIERS.filter((t) => TIER_PRIORITY[t] <= TIER_PRIORITY[tier]).map((t) =>
    productRoleName(productId, t)
  );
}
